import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-down-left', 'ArrowDownLeft', [["path",{"d":"m17.5 6.5-11 11m0 0h9m-9 0v-9","key":"svg-0"}]]);